//
//
//
//
//
//
//
//
//
//
//
//
//


export default {
  name: 'App',
  data() {
      return {
          mourningDay: false
      }
  },
  watch:{   //监听路由变化
    $route( to , from ){ 
        if (to.name == 'Index') {
            // let data = new Date()
            // let year = data.getFullYear()
            // let month = data.getMonth() +1
            // let day = data.getDate()
            // if (year == 2021 && month == 12 && day == 13) {
                this.mourningDay = true
            // }
        }  
    }
}
}



// WEBPACK FOOTER //
// ./src/App.vue